import {
    regexWithNumbers, regexWithoutNumbers, regexOnlyNumbers, regexNumbersSpecialChar,
    accountInputLen, groupInputLen, memberInputLen, gpiInputLen, regexNumbersSpecialCharLong, regexNumberWithStar
} from "../Utility/Constants";

export function validateRegexWithNumbers(name, value, inputError) {
    return updatedDataError(name, (value.length >= groupInputLen || !regexWithNumbers.test(value)), inputError);
}

export function validateRegexWithoutNumbers(name, value, inputError) {
    return updatedDataError(name, (value.length >= accountInputLen || !regexWithoutNumbers.test(value)), inputError);
}

export function validateRegexOnlyNumbers(name, value, inputError) {
    return updatedDataError(name, (value.length >= memberInputLen || !regexOnlyNumbers.test(value)), inputError);
}

export function validateRegexAlphaNumeric({
    name,
    value,
    inputError,
    maxLength
}) {
    return updatedDataError(name, (value.length >= maxLength || !regexWithNumbers.test(value)), inputError);
}

export function validateRegexNumbersSpecialChar(name, value, inputError) {
    return updatedDataError(name, (value.length >= gpiInputLen || !regexNumbersSpecialChar.test(value)), inputError);
}

export function validateRegexNumbersSpecialCharLong(name, value, inputError) {
    return updatedDataError(name, (value.length >= gpiInputLen || !regexNumbersSpecialCharLong.test(value)), inputError);
}

export function validateRegexNumbersCharSpecialCharLong(name, value, inputError) {
    return updatedDataError(name, (value.length >= gpiInputLen || !regexNumbersSpecialCharLong.test(value)), inputError);
}

export function validateRegexNumberWithStar(name, value, inputError) {
    return updatedDataError(name, (value.length >= gpiInputLen || !regexNumberWithStar.test(value)), inputError);
}

function updatedDataError(name, val, inputError) {
    const updatedDataError = {
        ...inputError,
        [name]: val
    };
    return updatedDataError;
}
